namespace h5_vm {
   export class GosFamilyConstants {
      static readonly WINDOWS: string = "windowsGuest";
      static readonly LINUX: string = "linuxGuest";
      static readonly OTHER: string = "otherGuestFamily";
   }

   angular.module("com.vmware.vsphere.client.vm")
         .constant("gosFamilyConstants", GosFamilyConstants);
}